import $http from '../../axios';

export async function getSales({commit, state}, dates) {
  commit('setLoading', true);

  await $http.get('/api/reporte-detalle-ventas?dates=' + dates)
    .then(async (response) => {
      await commit('setSales', response.data.data);
      commit('setLoading', false);
    }).catch(() => commit('setLoading', false));
}



// WEBPACK FOOTER //
// ./src/modules/sales-detail/actions.js